import type { ReactNode } from "react"
import Logo from "@rawa/ui/assets/logo.svg?react"
import styles from "./HappyLayout.module.scss"

type Props = {
  children: ReactNode
  heading?: ReactNode
}

export function HappyLayout({ children, heading }: Props) {
  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <Logo
          role="img"
          className={styles.logo}
          aria-label="Relationships Australia WA"
        />
        {heading}
      </header>
      <main className={styles.main}>{children}</main>
    </div>
  )
}
